module.exports = __webpack_public_path__ + "fonts/682fe21eef57a455db6721912fc1bed9.woff";